import { types } from 'mobx-state-tree';
import { Currency, CurrencyProps } from 'models/reusable-parts/currency';
import { BarGraph, BarGraphProps } from 'models/reusable-parts/bar-graph';

export interface RecurringTransactionsSingleRowProps {
  id: number;
  price: CurrencyProps;
  title: string;
  category: string;
  date: number;
  graphs: BarGraphProps[];
}

export const RecurringTransactionsSingleRow = types.model({
  id: types.number,
  price: Currency,
  title: types.string,
  category: types.string,
  date: types.number,
  graphs: types.optional(types.array(BarGraph), []),
});
